<template>
  <Menu awImgSrc="AW1.svg" activeItem="99" v-if="!$route.meta.hideNavbar"/>
  <router-view :key="$route.fullPath"/>
</template>

<script lang="ts">
import Menu from './components/Menu.vue'
import { provide, reactive, computed } from 'vue';

export default {
  setup() {
    const state = reactive({
      activeNavItem: "99"
    });

    const updateNavItem = (item: string) => {
      state.activeNavItem = item;
    };

    provide(
      "activeNavItem",
      computed(() => state.activeNavItem)
    );
    provide("updateNavItem", updateNavItem);

    return { state };
  },
  components: {
    Menu
  }
}
</script>

<style>
@font-face {
	font-family: 'MontserratSubrayada';
	src: url('./assets/fonts/MontserratSubrayada-Regular.ttf');
	font-weight: 400;
	font-stretch: 25% 151%;
  font-display: block;
}
@font-face {
	font-family: 'MontserratSubrayada';
	src: url('./assets/fonts/MontserratSubrayada-Bold.ttf');
	font-weight: 700;
	font-stretch: 25% 151%;
  font-display: block;
}
@font-face {
	font-family: 'Yantramanav';
	src: url('./assets/fonts/Yantramanav-Bold.ttf');
	font-weight: 600;
	font-stretch: 25% 151%;
  font-display: block;
}
@font-face {
	font-family: 'Yantramanav';
	src: url('./assets/fonts/Yantramanav-Light.ttf');
	font-weight: 300;
	font-stretch: 25% 151%;
  font-display: block;
}
@font-face {
	font-family: 'Yantramanav';
	src: url('./assets/fonts/Yantramanav-Medium.ttf');
	font-weight: 500;
	font-stretch: 25% 151%;
  font-display: block;
}
@font-face {
	font-family: 'Yantramanav';
	src: url('./assets/fonts/Yantramanav-Regular.ttf');
	font-weight: 400;
	font-stretch: 25% 151%;
  font-display: block;
}
@font-face {
	font-family: 'Yantramanav';
	src: url('./assets/fonts/Yantramanav-Thin.ttf');
	font-weight: 100;
	font-stretch: 25% 151%;
  font-display: block;
}
@font-face {
	font-family: 'Rajdhani';
	src: url('./assets/fonts/Rajdhani-Light.ttf');
	font-weight: 200;
	font-stretch: 25% 151%;
  font-display: block;
}
@font-face {
	font-family: 'Rajdhani';
	src: url('./assets/fonts/Rajdhani-Regular.ttf');
	font-weight: 400;
	font-stretch: 25% 151%;
  font-display: block;
}

:root {  
  --global-color: #f5f5f5;
  --global-backcolor: #1F1F1F;
  --black: #1F1F1F;
  --blue: #282e44;
  --red: #382727;
  --orange: #633527;
  --green: #253625;
  --turkis: #18423c;
  --greyLight: #777777;
  --greyMid: #5e5e5e;
  --greyDark: #2f2f2f;
}

body {
    margin: 0;
    font-family: 'Yantramanav', sans-serif;
    height: 100%;
    display: flex;
    flex-direction: column;
    font-size: 17px;
    background-color: var(--global-backcolor);
    color: var(--global-color);
    -webkit-transition: background-color 250ms linear;
    -ms-transition: background-color 250ms linear;
    transition: background-color 250ms linear;
}

h1 {
    font-family: 'Rajdhani', sans-serif;
    font-weight: 600;
    font-size: 2rem
}

h2 {
    font-family: 'Rajdhani', sans-serif;
    font-weight: 600;
    font-size: 1.7rem
}

h3 {
    margin-top: 0;
    font-family: 'Rajdhani', sans-serif;
    font-weight: 600;
    font-size: 1.5rem
}

.button {
  background-color: #1F1F1F;
  color: var(--global-color);
  border: 1px solid var(--global-color);
}

.button:hover,
.button:focus {
  transform: translateY(-0.25em);
  background-color: #292929;
}

@media only screen and (min-width: 1225px) {
/* scrollbar */
::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: var(--global-color);
}

::-webkit-scrollbar-thumb {
  background: #6c6c6c;
}

::-webkit-scrollbar-thumb:hover {
  background: #3b3b3b;
}
}

#app {
  height: 85%;
}

.scroll_wrapper {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    position: fixed;
}

.text_part{
    margin-right: 25%;
    margin-left: 25%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    align-self: flex-start !important;
}

.text_part > p {
    margin: 2px;
}

/* FB */
.fb_link {   
    position: fixed;
    bottom: 0;
    right: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    z-index: 10;
}

.fb_link > a {    
    margin-bottom: 15px;
    font-size: 0.9em;
}

.fb_link > a > img {
    width: 50px;
    height: 50px;
    margin-left: 5px;
}


@media only screen and (max-width: 1224px) {
  .fb_link {
    height: 48px;
    bottom: 5px !important;
    right: 20px !important;
  }

  .fb_link > a > img {
    width: 38px;
    height: 38px;
    margin-left: 5px;
    margin-top: 5px;
  }

  .text_part{
    margin-right: 10%;
    margin-left: 10%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    align-self: flex-start !important;
  }
}
</style>
